<footer id="footer">
  <div id="footer-top">
      <div class="container">
          <div class="row">
              <div class="col col-12 col-md">
                  <h4>{{ 'footer.trouvezNous' | translate }}</h4>

                  <p [innerHTML]="'footer.trouvezNousAdresse' | translate"></p>
              </div>
              <div class="col col-12 col-md">
                  <h4>{{ 'footer.contactezNous' | translate }}</h4>

                  <p [innerHTML]="'footer.contactezNousInfo' | translate"></p>
              </div>
              <div class="col col-12 col-md">
                  <h4>{{ 'footer.suivezNous' | translate }}</h4>
                  <a href="https://twitter.com/plurilogic" target="_blank"><i class="fa fa-twitter"></i></a>
                  <a href="https://linkedin.com/company/plurilogic" target="_blank"><i class="fa fa-linkedin"></i></a>
              </div>
              <div class="col col-12 col-md">
                <img class="faitauquebec" src="assets/img/footer/faitauquebec.svg" />
            </div>
        </div>
      </div>
  </div>
  <div id="footer-bottom">
      <div class="container">
          <div class="row">
              <div class="col col-12 col-lg-6">
                  <p>&copy;{{ 'footer.copyright' | translate }}</p>
              </div>
              <div class="col col-12 col-lg-6">
                  <ul>
                      <li>
                          <a [routerLink]="'/condutil'">{{ 'footer.conditionsUtilisations' | translate }}</a>
                      </li>
                      <li>
                          <a [routerLink]="'/polvieprive'">{{ 'footer.politiqueViePrivee' | translate }}</a>
                      </li>
                      <li>
                          <a *ngIf="currentLanguage === 'en'" href="" (click)="doChangeLanguage($event, 'fr')">Français</a>
                          <a *ngIf="currentLanguage === 'fr'" href="" (click)="doChangeLanguage($event, 'en')">English</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</footer>
